import { render, staticRenderFns } from "./ColorPresentation.vue?vue&type=template&id=132e0512"
import script from "./ColorPresentation.vue?vue&type=script&lang=js"
export * from "./ColorPresentation.vue?vue&type=script&lang=js"
import style0 from "./ColorPresentation.vue?vue&type=style&index=0&id=132e0512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports